import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface TransitProps {
  id: string;
}

export const useCustomsSyncTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: TransitProps) => {
      return request({
        path: `transits/${id}/customs-sync`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`Transit synced successfully!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error syncing the transit!`);
    },
  });
};
